import { DateTimeUtils } from "@stellar/utils";
/** Value of the area filter that shows every area */
export const ALL_AREAS = "all";

/** How recently the photos must have been captured to be shown */

/** Options of the last captured filter */
export const CAPTURE_DATE_FILTER_OPTIONS = [{
  value: "anyTime",
  label: "Any time"
}, {
  value: "last7Days",
  label: "Last 7 days"
}, {
  value: "last30Days",
  label: "Last 30 days"
}, {
  value: "last365Days",
  label: "Last year"
}];

/** Amount of days of each date filter, none to keep every photo */
const CAPTURE_DATE_FILTER_DAYS = {
  anyTime: undefined,
  last7Days: 7,
  last30Days: 30,
  last365Days: 365
};

/** Label of the photos that are not in any area */
const NO_AREA_LABEL = "Without area";

/** Amounts shown in the stat tiles */

/** @returns the photos in the selected area, captured within the selected period */
export function filterCaptures(captures, {
  areaId,
  dateFilter,
  now
}) {
  const days = CAPTURE_DATE_FILTER_DAYS[dateFilter];
  const minDate = days ? now - days * DateTimeUtils.MILLISECONDS_IN_DAY : 0;
  return captures.filter(capture => (areaId === ALL_AREAS || capture.areaId === areaId) && new Date(capture.createdAt).getTime() >= minDate);
}

/** @returns the amount of photos per area, most captured first, leaving out areas without photos */
export function getCapturesPerArea(captures, areas) {
  const areaNames = new Map(areas.map(({
    id,
    name
  }) => [id, name]));
  const counts = new Map();
  for (const {
    areaId
  } of captures) {
    const label = areaId && areaNames.get(areaId) || NO_AREA_LABEL;
    counts.set(label, (counts.get(label) ?? 0) + 1);
  }
  return [...counts].map(([label, value]) => ({
    label,
    value
  })).sort((a, b) => b.value - a.value);
}

/** @returns the amounts shown in the stat tiles */
export function getCaptureStats(captures) {
  const videoModeCaptures = captures.filter(({
    kind
  }) => kind === "videoMode");
  const lastCapturedAt = captures.reduce((latest, {
    createdAt
  }) => !latest || new Date(createdAt) > new Date(latest) ? createdAt : latest, undefined);
  return {
    singleCount: captures.length - videoModeCaptures.length,
    videoModeCount: videoModeCaptures.length,
    videoModeSessionCount: new Set(videoModeCaptures.map(({
      videoModeSessionId
    }) => videoModeSessionId)).size,
    lastCapturedAt
  };
}